import { Button, styled } from "@mui/material";

export const SwitchModalSubmit = styled(Button)(() => ({
  width: "100%",
  height: "66px",
  fontSize: "16px",
  textTransform: "uppercase",
  fontFamily: "inherit",
  fontWeight: 600,
  color: "#fff !important",
  borderRadius: 0,
  background: "#000",
  margin: "0 auto",
  "&:hover": {
    background: "#000",
  },
  "&.Mui-disabled": {
    background: "transparent",
  },
}));
